import React from 'react'

type Props = {
    className?      : string

    option          : any

    isHighlighted?  : boolean
    isSelected?     : boolean

    onClick?        : func
    onDelete?       : func
}

export default class FieldExpenseApprovalStatus_PopoverOption extends React.Component<Props,any> {

    onClick = () => {
        this.props.onClick && this.props.onClick(this.props.option)
    }

    onDelete = (e: React.MouseEvent) => {
        e.stopPropagation()
        this.props.onDelete && this.props.onDelete(this.props.option)
    }

    render() {
        const classes = Classes('ui5-status-list status-c{0}'.f(this.props.option.color), this.props.className)

        return (
            <div className={classes} onClick={this.onClick}>
                <div className="max-w-100-percent txt-truncate">{this.props.option.label}</div>

                {this.props.onDelete &&
                    <div className="delete-button centered ui5-ico-delete s14 gray" onClick={this.onDelete}/>
                }
            </div>
        )
    }
}
